<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <form-group :label="$t('warranty.label')" :required="true" :error="getError('product.warranty', product.productId)">
      <input class="form-input" type="number" v-model="product.warranty" :disabled="disabledInputs()">
    </form-group>
  </shared-product-provide>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'webcontinental'
      },
      maxDescriptionLengthDI: 10000,
      allowDescriptionHtml: true
    },
    data: () => ({
      loadingProductTypes: false,
      loadingAttributes: false
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$parent.loadingProducts(false)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'getError',
        'clearErrors'
      ]),
      formatProduct () {
        this.clearErrors()

        if (this.product.warranty === null || this.product.warranty === '') {
          this.addError({
            productId: this.product.productId,
            property: `product.warranty`,
            error: {
              message: 'required',
              value: 1
            }
          })
        }

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => ({
            attributes: [],
            brand: this.product.brand,
            color: variation.attributes.color !== undefined && variation.attributes.color !== null ? variation.attributes.color : 'Única',
            size: variation.attributes.size !== undefined && variation.attributes.size !== null ? variation.attributes.size : 'Único',
            description: this.product.description,
            ean: variation.ean,
            height: variation.height,
            images: variation.images.length ? variation.images : null,
            integrationCode: this.product.productId,
            length: variation.length,
            original: {
              product: this.product,
              variation: variation
            },
            price: variation.price,
            sku: variation.sku,
            source: this.fromModule,
            stock: variation.stock,
            title: this.product.title,
            weight: variation.weight,
            width: variation.width,
            warranty: this.product.warranty
          })
        )
      },
      disabledInputs () {
        return this.product.status === 'sent' || this.product.status === 'error'
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ])
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?35749e82